import React, { useState, useEffect, useContext } from "react";
import ijws from "../../../services/ijws";
import { formatDateTime } from "../../../helpers/helpers";
import modalidadeAssinatura from "../../../enums/modalidadeAssinatura";
import AppContext from "../../../container/context";
import Form from "../../../components/form";
import { Button, CircularProgress, Stack } from "@mui/material";

const Promocao = ({ match, history }) => {
  const { notification } = useContext(AppContext);
  const planoId = Number(match.params.id);
  const [carregando, setCarregando] = useState(false);
  const [plano, setPlano] = useState({});

  useEffect(() => {
    if (planoId > 0) {
      carregar();
    }
  }, [planoId]);

  const carregar = () => {
    setCarregando(true);
    ijws
      .get("admin/planos/carregar", { id: planoId })
      .then((plano) => {
        plano.valorCentavos = (plano.valorCentavos / 100).toFixed(2);
        setPlano(plano);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível carregar o plano");
        setCarregando(false);
      });
  };

  const salvarCampos = (campo, valor) => {
    console.log("🚀 ~ salvarCampos ~ valor:", valor);
    console.log("🚀 ~ salvarCampos ~ campo:", campo);

    const atualizarCampos = { ...plano };
    atualizarCampos[campo] = valor;
    setPlano(atualizarCampos);
  };

  const camposPlano = (plano) => {
    const campos = {};
    campos.nome = {
      label: "Nome",
      type: "text",
      value: plano.nome,
      required: true,
      space: 8,
    };
    campos.identificador = {
      label: "Identificador",
      type: "text",
      value: plano.identificador,
      required: true,
      space: 4,
    };
    campos.descricao = {
      label: "Descrição",
      type: "textarea",
      value: plano.descricao,
      space: 12,
    };
    campos.valorCentavos = {
      label: "Valor R$",
      type: "number",
      value: plano.valorCentavos,
      space: 6,
      required: true,
    };
    campos.modalidadeAssinatura = {
      label: "Modalidade da assinatura",
      type: "select",
      domain: modalidadeAssinatura,
      value: plano.modalidadeAssinatura,
      space: 6,
      emptyItem: true,
      emptyItemText: "(Selecione)",
      required: true,
    };

    if (plano.modalidadeAssinatura === 1) {
      campos.idPlanoIugu = {
        label: "ID do plano na Iugu",
        type: "text",
        value: plano.idPlanoIugu,
        space: 12,
      };
    }

    if (plano.modalidadeAssinatura === 2) {
      campos.qtdParcelas = {
        label: "Quantidade máxima de parcela",
        type: "number",
        value: plano.qtdParcelas,
        space: 6,
      };

      campos.mesesAssinatura = {
        label: "Duração da assinatura (meses)",
        type: "number",
        value: plano.mesesAssinatura,
        space: 6,
      };
    }

    campos.inicioVigencia = {
      label: "Vigente a partir de",
      type: "date",
      value: plano.inicioVigencia
        ? formatDateTime(plano.inicioVigencia, "Y-M-D")
        : null,
      required: true,
      space: 6,
    };

    campos.fimVigencia = {
      label: "Vigente até",
      type: "date",
      value: plano.fimVigencia
        ? formatDateTime(plano.fimVigencia, "Y-M-D")
        : null,
      space: 6,
    };

    campos.qtdPerfisAcesso = {
      label: "Quantidade de perfis de acesso",
      type: "number",
      value: plano.qtdPerfisAcesso,
      space: 6,
    };

    campos.principal = {
      label: "Principal",
      type: "check",
      value: plano.principal,
      space: 6,
    };

    campos.componente = {
      type: "component",
      value: (
        <Stack direction={"row"} spacing={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={salvar}
            style={{ color: "white" }}
          >
            Salvar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => history.goBack()}
          >
            cancelar
          </Button>
        </Stack>
      ),
      space: 6,
    };

    return campos;
  };

  const salvar = () => {
    if (plano.modalidadeAssinatura === 2) {
      if (!plano.mesesAssinatura)
        return notification(
          "warning",
          "Selecione a quantidade de meses de assinatura"
        );
    }

    const planoSalvar = plano;
    planoSalvar.valorCentavos = Number(planoSalvar.valorCentavos) * 100;

    if (planoId > 0) {
      planoSalvar.id = planoId;
      ijws
        .post("admin/planos/editar", planoSalvar)
        .then((res) => {
          notification("success", "Plano salvo!");
          history.goBack();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Valor inválido");
            case 3:
              return notification("error", "Início de vigência inválido");

            default:
              return notification("error", "Erro ao inserir plano");
          }
        });
    } else {
      ijws
        .post("admin/planos/inserir", planoSalvar)
        .then((res) => {
          notification("success", "Plano salvo!");
          history.goBack();
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Valor inválido");
            case 3:
              return notification("error", "Início de vigência inválido");

            default:
              return notification("error", "Erro ao inserir plano");
          }
        });
    }
  };

  const fPlano = {
    title: "Plano",
    form: camposPlano(plano),
    autoSave: salvarCampos,
  };

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fPlano} />
        </>
      )}
    </div>
  );
};

export default Promocao;
